<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "TypeDocumentIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
